export const iconFontAwesomeArrowsAnglesLeft = (
	<i className="fa-solid fa-angles-left"></i>
);
